// extracted by mini-css-extract-plugin
export default {"container":"ActivityButton_container__sOtdz","indicator":"ActivityButton_indicator__t122n"};